export interface ILocaleInfo {
  locale: string;
  userDefaultLocale?: string;
}

export interface ITranslationService {
  getMetricNameTranslation: (metricId: string, defaultLabel: string, locale: string) => string;
  getReportTitleTranslation: (value: string, locale: string) => string;
  getLabelTranslation: (value: string, locale: string) => string;
  getChartDimensions: (value: string, locale: string) => string;
  getChannels?: (value: string, locale: string) => string;
}





